<template>
  <div class="content">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <md-card class="md-card-plain">
          <md-card-header>
            <h4 class="title"><b>Mayai Daily Reports</b></h4>
          </md-card-header>
          <md-card-content>
            <template>
              <div class="md-layout md-alignment-top-center mt-6 p-0">
                <div
                  class="md-layout-item md-size-90 md-medium-size-85 md-xsmall-size-100 p-0"
                >
                  <div class="md-layout md-alignment-top-right">
                    <MonthPicker
                      class="md-layout-item md-alignment-top-right"
                      :hideClearButton="true"
                      @setYear="getYear($event)"
                      @setMonth="getMonth($event)"
                    ></MonthPicker>
                  </div>
                </div>
              </div>
              <div>
                <md-table v-model="reports">
                  <md-table-row slot="md-table-row" slot-scope="{ item }">
                    <md-table-cell>
                      {{ item.name }}
                      <span v-if="loading">(DOWNLOADING . . .)</span>
                    </md-table-cell>
                    <md-table-cell>
                      <div>
                        <md-button
                          class="md-just-icon md-simple md-success"
                          @click="getReport(item, selected)"
                        >
                          <md-icon>download</md-icon>
                          <md-tooltip md-direction="top">Download</md-tooltip>
                        </md-button>
                      </div>
                    </md-table-cell>
                  </md-table-row>
                </md-table>
              </div>
            </template>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "@/services/ApiService";
import MonthPicker from "@/components/MonthPicker.vue";
import Api from "@/services/api";

export default {
  components: {
    MonthPicker
  },
  props: {
    tableHeaderColor: {
      type: String,
      default: "green"
    }
  },
  data() {
    return {
      reports: [
        {
          code: "report01",
          name: "Report 1 - Get Report Daily Metrics",
          desciption: "computed daily"
        }
      ],
      selected: { year: null, month: null, days: null },
      selectedYear: null,
      loading: false,
      call_details: [],
      year: null,
      month: { number: null, name: "", days: "" }
    };
  },
  watch: {
    selected: {
      handler(nVal, oVal) {
        console.log(nVal, oVal);
        this.setQuery();
      },
      deep: true
    }
  },
  async created() {
    //
  },
  async mounted() {
    this.selected = this.setQuery();
  },
  methods: {
    pad(n) {
      return n < 10 ? "0" + n : n;
    },
    getYear(e) {
      this.selected.year = this.year;
      this.year = e;
    },
    getMonth(e) {
      this.selected.month = this.month.number;
      this.month = e;
    },
    async getReport(item, query) {
      this.loading = true;
      const str = new URLSearchParams(query).toString();
      await Api()
        .get(`/get_daily_report_metrics?${str}`, { responseType: "blob" })
        .then(response => {
          const href = URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = href;
          const startDate = `${query.year}-${query.month}-01`;
          const endDate = `${query.year}-${query.month}-${query.days}`;
          link.setAttribute(
            "download",
            `${item.name}-${startDate}-to-${endDate}`
          ); //or any other extension
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
          this.loading = false;
        })
        .catch(e => {
          console.error(e);
          this.loading = false;
        });
    },
    setQuery() {
      const query = Object.assign({}, this.$route.query);
      query.year = this.year;
      query.month = this.pad(this.month.number);
      query.days = this.month.days;
      this.selected.month = query.month;
      this.selected.year = query.year;
      this.selected.days = query.days;
      this.$router.replace({ query });
      return query;
    }
  }
};
</script>
